import InfoToggletip from 'components/InfoToggletip';
import * as S from './LabelStyles';
import getCommonTestId from '@/main/constants/testsIds/common';

export interface LabelProps {
  paidContentLabel: string;
}

export const Label = ({ paidContentLabel }: LabelProps) => (
  <S.Label data-cy={getCommonTestId('BRANDED_ARTICLE_PAID_CONTENT_LABEL')}>
    {paidContentLabel || 'Paid Content'}
    <InfoToggletip
      variant='black'
      position='bottom-right'
      content='This content was created and paid for by the listed company. FORTUNE editorial staff was not involved in its creation or production.'
      color='iconPrimary'
    />
  </S.Label>
);

export default Label;
